interface IRendition {
  type: string
  formats: { jpg?: string }
}

export const getImage = (renditions: IRendition[]): string | null => {
  const image = renditions.find(({ type }) => type === 'article_body_image')
  return image?.formats.jpg ? `${process.env.MEDIA_BASE_PATH ?? '/'}${image.formats.jpg}` : null
}
